module.exports = __webpack_public_path__ + "img/tips.191934ba.png";